const RulesPage = () => {
  return (
    <div className="p-5 shadow-lg rounded-md border border-stone-100 bg-white">
      <h1 className="text-lg font-bold mb-3">قوانین و مقررات</h1>
      <ul className="pr-3">
        <li className="list-disc mb-3 text-slate-700">
          در صورت اجرا نشدن تور به هر دلیلی و عدم اطلاع قبلی کنسلی تور تا ساعت
          12 ظهر روز اجرا، مبلغ ده درصد کل تور به عنوان جریمه در نظر گرفته خواهد
          شد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت نیاز به جابه&zwnj;جایی تور، تامین کننده موظف است تا ساعت 12
          ظهر روز اجرا تغییرات را به اطلاع کایت برساند، در غیر این صورت مبلغ 10
          درصد از کل تور به عنوان جریمه منظور خواهد شد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت نیاز به تغییر وسیله نقلیه تور (مثلا از توریستی به VIP یا
          بلعکس) و عدم اطلاع آن تا ساعت 12 ظهر روز اجرا، مبلغ 10 درصد از کل تور
          به عنوان جریمه منظور خواهد شد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت پر شدن ظرفیت تور و عدم اطلاع آن توسط تامین کننده به کایت و
          انجام شدن رزرو توسط مسافر، تورهای تامین کننده تا یک هفته بر روی سایت
          کایت نمایش داده نخواهد شد و در صورت تکرار آن، در مورد ادامه همکاری
          تصمیم گیری به عمل خواهد آمد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت عدم رضایت مسافر از تور و نحوه&zwnj;ی اجرای آن، تمامی مسئولیت
          با مجری تور خواهد بود و مبلغ تور نزد کایت تا زمان جلب رضایت مسافر باقی
          خواهد ماند. (این در حالتی است که حق با مسافر باشد.)
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت شکایت مسافر از تور و نحوه&zwnj;ی اجرای آن، تمامی مسئولیت با
          مجری تور خواهد بود و مبلغ تور نزد کایت تا زمان بررسی از طرف سازمان
          خواهد ماند.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت مشاهده قیمت گذاری تور در سایت&zwnj;های مشابه با مبلغ
          پایین&zwnj;تر، نمایش تورهای تامین کننده یک هفته تعلیق خواهد شد و در
          صورت 3 بار تکرار این مورد، تعلیق دائمی تامین کننده را به دنبال خواهد
          داشت.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          اگر مسافران اقدام به اضافه کردن تعداد نفرات به صورت مستقیم با تامین
          کننده کنند و تامین کننده این مورد را به کایت اطلاع ندهد، مبلغ کمیسیون
          فرد اضافه شده دو برابر محاسبه و در صورت تکرار تامین کننده تعلیق خواهد
          شد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت عدم رسیدن پیام سفر تا ساعت 16 روز اجرا، مبلغ 10 درصد از کل تور
          به عنوان جریمه محاسبه و منظور خواهد شد.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          در صورت کنسلی تور و عدم اطلاع آن تا 4 ساعت قبل از شروع تور، بنا به
          شرایط حداقل نصف تا کل مبلغ تور به عنوان جریمه منظور شده و تامین کننده
          موظف است این مبلغ را به کایت پرداخت کند.
        </li>
        <li className="list-disc mb-3 text-slate-700">
          تامین کنندگان حق تبلیغ خودشان را به مسافران کایت (مثلا معرفی پیج
          اینستاگرام) ندارند و در صورت اطلاع کایت از این مورد، در مورد ادامه
          همکاری تصمیم گیری خواهد شد.
        </li>
      </ul>
    </div>
  );
};

export default RulesPage;
